"use client"

import { useEffect, useMemo, useState } from "react"
import {
  MagnifyingGlass,
  DownloadSimple,
  FunnelSimple,
  X,
  ArrowClockwise,
  SpinnerGap,
  Activity,
  ArrowRight,
  CurrencyDollar,
  CaretLeft,
  CaretRight,
  CaretDoubleLeft,
  CaretDoubleRight,
  CaretDown,
  PlusCircle,
  GlobeHemisphereWest,
  Eye,
  WarningCircle,
  Fingerprint,
  Briefcase,
  IdentificationCard,
  EnvelopeSimple,
  ShieldCheck,
  HashStraight,
  TagSimple,
  Coins,
  CurrencyCircleDollar,
  Buildings,
  GearSix,
  User as UserIcon,
  UserCircle,
  CalendarBlank,
  Handshake,
  Storefront,
  Phone,
  DeviceMobile,
  Note,
  NotePencil,
  Gear,
  ArrowsLeftRight,
  PencilSimple,
  ShareNetwork,
  TrashSimple,
  Globe,
  GitBranch,
  SquaresFour,
  Key,
} from "phosphor-react"

import { useNavigate, useParams } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"

import adAccountsService from "../../services/adAccountsService"
import transferHistoryService from "../../services/transferHistoryService"
import { DateRangePicker, SearchableSelect } from "../../components"
import { useCurrentUser } from "../../utils/context/UserProvider"
import { useAccessChecker } from "../../utils/Functions/Authorization"
import formatDateGlobal from "../../utils/Functions/formatDateGlobal"

// your modals
import TransactionDetailsModal from "./TransactionDetailsModal"
import ChangeStatusModal from "./ChangeStatusModal"
import ReshareBMModal from "./ReshareBMModal"
import ChangeAdAccountNameDialog from "./ChangeAdAccountNameDialog"
import WithdrawBalanceModal from "../AdAccounts/TopDown"
import ApproveRejectModal from "./ApproveRejectModal"

/* ------------------------------------------
   Platform Icon
-------------------------------------------*/
const getPlatformIcon = (platform) => {
  switch (platform) {
    case "meta":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
          <path
            fill="#0081fb"
            d="M47,29.36l-2.193,1.663L42.62,29.5c0-0.16,0-0.33-0.01-0.5c0-0.16,0-0.33-0.01-0.5 c-0.14-3.94-1.14-8.16-3.14-11.25c-1.54-2.37-3.51-3.5-5.71-3.5c-2.31,0-4.19,1.38-6.27,4.38c-0.06,0.09-0.13,0.18-0.19,0.28 c-0.04,0.05-0.07,0.1-0.11,0.16c-0.1,0.15-0.2,0.3-0.3,0.46c-0.9,1.4-1.84,3.03-2.86,4.83c-0.09,0.17-0.19,0.34-0.28,0.51 c-0.03,0.04-0.06,0.09-0.08,0.13l-0.21,0.37l-1.24,2.19c-2.91,5.15-3.65,6.33-5.1,8.26C14.56,38.71,12.38,40,9.51,40 c-3.4,0-5.56-1.47-6.89-3.69C1.53,34.51,1,32.14,1,29.44l4.97,0.17c0,1.76,0.38,3.1,0.89,3.92C7.52,34.59,8.49,35,9.5,35 c1.29,0,2.49-0.27,4.77-3.43c1.83-2.53,3.99-6.07,5.44-8.3l1.37-2.09l0.29-0.46l0.3-0.45l0.5-0.77c0.76-1.16,1.58-2.39,2.46-3.57 c0.1-0.14,0.2-0.28,0.31-0.42c0.1-0.14,0.21-0.28,0.31-0.41c0.9-1.15,1.85-2.22,2.87-3.1c1.85-1.61,3.84-2.5,5.85-2.5 c3.37,0,6.58,1.95,9.04,5.61c2.51,3.74,3.82,8.4,3.97,13.25c0.01,0.16,0.01,0.33,0.01,0.5C47,29.03,47,29.19,47,29.36z"
          ></path>
          <linearGradient id="meta_g1" x1="42.304" x2="13.533" y1="24.75" y2="24.75" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#0081fb"></stop>
            <stop offset=".995" stopColor="#0064e1"></stop>
          </linearGradient>
          <path
            fill="url(#meta_g1)"
            d="M4.918,15.456 C7.195,11.951,10.483,9.5,14.253,9.5c2.184,0,4.354,0.645,6.621,2.493c2.479,2.02,5.122,5.346,8.419,10.828l1.182,1.967 c2.854,4.746,4.477,7.187,5.428,8.339C37.125,34.606,37.888,35,39,35c2.82,0,3.617-2.54,3.617-5.501L47,29.362 c0,3.095-0.611,5.369-1.651,7.165C44.345,38.264,42.387,40,39.093,40c-2.048,0-3.862-0.444-5.868-2.333 c-1.542-1.45-3.345-4.026-4.732-6.341l-4.126-6.879c-2.07-3.452-3.969-6.027-5.068-7.192c-1.182-1.254-2.642-2.754-5.067-2.754 c-1.963,0-3.689,1.362-5.084,3.465L4.918,15.456z"
          ></path>
        </svg>
      );
    case "google":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
          <polygon fill="#ffc107" points="30.129,15.75 18.871,9.25 5.871,31.25 17.129,37.75"></polygon>
          <path
            fill="#1e88e5"
            d="M31.871,37.75c1.795,3.109,5.847,4.144,8.879,2.379c3.103-1.806,4.174-5.77,2.379-8.879l-13-22 c-1.795-3.109-5.835-4.144-8.879-2.379c-3.106,1.801-4.174,5.77-2.379,8.879L31.871,37.75z"
          ></path>
          <circle cx="11.5" cy="34.5" r="6.5" fill="#43a047"></circle>
        </svg>
      );
    case "tiktok":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 48 48" aria-hidden="true">
          <path
            fill="#212121"
            fillRule="evenodd"
            d="M10.904,6h26.191C39.804,6,42,8.196,42,10.904v26.191 C42,39.804,39.804,42,37.096,42H10.904C8.196,42,6,39.804,6,37.096V10.904C6,8.196,8.196,6,10.904,6z"
            clipRule="evenodd"
          ></path>
          <path
            fill="#ec407a"
            fillRule="evenodd"
            d="M29.208,20.607c1.576,1.126,3.507,1.788,5.592,1.788v-4.011 c-0.395,0-0.788-0.041-1.174-0.123v3.157c-2.085,0-4.015-0.663-5.592-1.788v8.184c0,4.094-3.321,7.413-7.417,7.413 c-1.528,0-2.949-0.462-4.129-1.254c1.347,1.376,3.225,2.23,5.303,2.23c4.096,0,7.417-3.319,7.417-7.413L29.208,20.607z M30.657,16.561c-0.805-0.879-1.334-2.016-1.449-3.273v-0.516h-1.113C28.375,14.369,29.331,15.734,30.657,16.561z M19.079,30.832c-0.45-0.59-0.693-1.311-0.692-2.053c0-1.873,1.519-3.391,3.393-3.391c0.349,0,0.696,0.053,1.029,0.159v-4.1 c-0.389-0.053-0.781-0.076-1.174-0.068v3.191c-0.333-0.106-0.68-0.159-1.03-0.159c-1.874,0-3.393,1.518-3.393,3.391 C17.213,29.127,17.972,30.274,19.079,30.832z"
            clipRule="evenodd"
          ></path>
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M28.034,19.63c1.576,1.126,3.507,1.788,5.592,1.788v-3.157 c-1.164-0.248-2.194-0.856-2.969-1.701c-1.326-0.827-2.281-2.191-2.561-3.788h-2.923v16.018c-0.007,1.867-1.523,3.379-3.393,3.379 c-1.102,0-2.081-0.525-2.701-1.338c-1.107-0.558-1.866-1.705-1.866-3.029c0-1.873,1.519-3.391,3.393-3.391 c0.359,0,0.705,0.056,1.03,0.159V21.38c-4.024,0.083-7.26,3.369-7.26,7.411c0,2.018,0.806,3.847,2.114,5.183 c1.18,0.792,2.601,1.254,4.129,1.254c4.096,0,7.417-3.319,7.417-7.413z"
            clipRule="evenodd"
          ></path>
          <path
            fill="#81d4fa"
            fillRule="evenodd"
            d="M33.626,18.262v-0.854c-1.05,0.002-2.078-0.292-2.969-0.848 C31.445,17.423,32.483,18.018,33.626,18.262z M28.095,12.772c-0.027-0.153-0.047-0.306-0.061-0.461v-0.516h-4.036v16.019 c-0.006,1.867-1.523,3.379-3.393,3.379c-0.549,0-1.067-0.13-1.526-0.362c0.62,0.813,1.599,1.338,2.701,1.338 c1.87,0,3.386-1.512,3.393-3.379V12.772H28.095z M21.635,21.38v-0.909c-0.337-0.046-0.677-0.069-1.018-0.069 c-4.097,0-7.417,3.319-7.417,7.413c0,2.567,1.305,4.829,3.288,6.159c-1.308-1.336-2.114-3.165-2.114-5.183 C14.374,24.749,17.611,21.463,21.635,21.38z"
            clipRule="evenodd"
          ></path>
        </svg>
      );
    case "snapchat":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
          <path
            fill="#ffeb3b"
            d="M24,4C12.402,4,3,13.402,3,25c0,11.598,9.402,21,21,21s21-9.402,21-21C45,13.402,35.598,4,24,4z"
          ></path>
          <path
            fill="#fff"
            d="M24,36c-2.451,0-4.045-1.09-4.827-1.612c-0.477-0.317-0.924-0.616-1.317-0.705 c-0.345-0.078-0.685-0.118-1.012-0.118c-0.59,0-1.056,0.103-1.386,0.175c-0.207,0.045-0.385,0.084-0.526,0.084 c-0.143,0-0.298-0.032-0.367-0.267c-0.064-0.218-0.107-0.428-0.148-0.631c-0.116-0.568-0.198-0.92-0.416-0.954 c-2.562-0.401-3.295-0.945-3.464-1.331c-0.024-0.055-0.037-0.11-0.04-0.165c-0.008-0.138,0.09-0.258,0.227-0.283 c3.731-0.614,5.399-4.44,5.467-4.589c0.004-0.009,0.008-0.017,0.012-0.026c0.225-0.456,0.268-0.851,0.131-1.174 c-0.258-0.611-1.099-0.879-1.657-1.058c-0.137-0.044-0.268-0.086-0.371-0.126c-0.504-0.198-1.349-0.612-1.241-1.186 c0.078-0.416,0.615-0.707,1.049-0.707c0.12,0,0.226,0.021,0.316,0.063c0.518,0.242,0.986,0.364,1.392,0.364 c0.558,0,0.802-0.236,0.833-0.266c-0.015-0.273-0.033-0.557-0.051-0.846c-0.119-1.922-0.268-4.313,0.337-5.674 C18.915,13.058,22.304,13,23.104,13h0.792c0.8,0,4.189,0.058,6.254,3.347c0.605,1.359,0.456,3.75,0.337,5.673 c-0.018,0.29-0.036,0.573-0.051,0.847c0.031,0.03,0.275,0.266,0.833,0.266c0.406,0,0.874-0.122,1.392-0.364 c0.09-0.042,0.196-0.063,0.316-0.063c0.433,0,0.971,0.291,1.049,0.707c0.108,0.574-0.737,0.988-1.241,1.186 c-0.103,0.04-0.234,0.082-0.371,0.126c-0.558,0.179-1.399,0.447-1.657,1.058c-0.137,0.323-0.094,0.718,0.131,1.174 c0.004,0.009,0.008,0.017,0.012,0.026c0.068,0.149,1.736,3.975,5.467,4.589c0.137,0.025,0.235,0.145,0.227,0.283 c-0.003,0.055-0.016,0.11-0.04,0.165c-0.169,0.386-0.902,0.93-3.464,1.331c-0.218,0.034-0.224,0.267-0.367,0.267 c-0.142,0-0.319-0.039-0.526-0.084 c-0.33-0.072-0.796-0.175-1.386-0.175c-0.327,0-0.667,0.04-1.012,0.118c-0.393,0.089-0.84,0.388-1.317,0.705 C28.045,34.91,26.451,36,24,36z"
          ></path>
        </svg>
      );
    default:
      return <Globe size={18} className="text-neutral-800 dark:text-neutral-400" />;
  }
};

const getDecisionBadge = (decision) => {
  const d = (decision || "").toLowerCase()
  if (d === "approved") return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-600"
  if (d === "rejected") return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-600"
  return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-600"
}
const getDecisionLabel = (decision) => {
  const d = (decision || "").toLowerCase()
  if (d === "approved") return "Approved"
  if (d === "rejected") return "Rejected"
  return "Pending"
}

/* ------------------------------------------
   Small UI helpers
-------------------------------------------*/
const InfoRow = ({ label, value, badge = false, icon = null }) => {
  const display = value ?? "N/A"
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-center gap-2 text-neutral-500 dark:text-neutral-400">
        {icon ? <span className="text-neutral-400 dark:text-neutral-500">{icon}</span> : null}
        <span className="text-sm">{label || "-None-"}</span>
      </div>
      {badge ? (
        <span className="text-xs px-2.5 py-0.5 rounded-full bg-green-600/10 text-green-700 dark:bg-green-900/20 dark:text-green-400 font-medium">
          {display}
        </span>
      ) : (
        <span className="text-sm font-medium text-neutral-900 dark:text-white">{display}</span>
      )}
    </div>
  )
}

const NotesBox = ({ title, content, icon }) => (
  <div className="p-5 rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
    <h3 className="mb-3 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
      {icon}
      {title}
    </h3>
    <p className="text-sm text-start text-neutral-700 dark:text-neutral-300 leading-relaxed">{content}</p>
  </div>
)

/* ------------------------------------------
   Identifiers Card (PER-ITEM decision ✅)
-------------------------------------------*/
const IdentifiersCard = ({ account, currentUser, onOpenDecision }) => {
  const { checkAccess } = useAccessChecker()
  const platform = account?.platform
  // Follows the adAccounts.update permission (the same one the server's
  // identifier-decision route requires), not a hardcoded role name.
  const canDecide = currentUser?.role?.name !== "Client" && checkAccess("adAccounts", "update")

  const DecisionBtn = ({ decision, payload }) => {
    const d = (decision || "pending").toLowerCase()
    const isPending = d === "pending"

    return (
      <button
        disabled={!canDecide || !isPending}
        onClick={() => {
          if (!canDecide || !isPending) return
          onOpenDecision?.(payload)
        }}
        className={`h-8 px-3 rounded-xl text-[12px] font-medium inline-flex items-center justify-center
          ${getDecisionBadge(d)}
          ${isPending ? "hover:opacity-90" : " cursor-not-allowed"}
        `}
        title={isPending ? "Click to approve or reject" : "Decision completed"}
      >
        {getDecisionLabel(d)}
      </button>
    )
  }

  return (
    <div className="p-5 rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
      <h3 className="mb-4 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
        <Fingerprint size={16} />
        Identifiers
      </h3>

      <div className="space-y-4">
        {/* META: BM IDs */}
        {platform === "meta" && Array.isArray(account?.bmIds) && account.bmIds.length > 0 && (
          <div className="text-start space-y-2">
            <span className="flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
              <Briefcase size={16} />
              Client BM
            </span>

            <div className="mt-1 grid gap-3 max-h-48 overflow-y-auto">
              {[...account.bmIds].reverse().map((bm, index) => (
                <div
                  key={bm._id || bm.bmId || index}
                  className="flex items-center justify-between gap-3 px-3 py-2 rounded-xl bg-neutral-50 dark:bg-neutral-900/40"
                >
                  <div className="flex flex-col">
                    <span className="font-[400] text-[14px] text-neutral-800 dark:text-neutral-100">
                      {bm.bmId || "Unknown BM ID"}
                    </span>
                    <span className="text-[11px] text-neutral-500 dark:text-neutral-400 flex items-center gap-1">
                      <CalendarBlank size={12} />
                      {bm.date
                        ? new Date(bm.date).toLocaleDateString()
                        : "Created date N/A"}
                    </span>
                  </div>

                  <DecisionBtn
                    decision={bm.decision}
                    payload={{
                      kind: "meta_bm",
                      identifierId: bm._id,
                      value: bm.bmId,
                      accountId: account?._id,
                      AdaccountId: account?.adAccountId,
                      index,
                    }}
                  />
                </div>
              ))}
            </div>

          </div>
        )}

        {/* TikTok: Business Center IDs (still bmIds array) */}
        {platform === "tiktok" && Array.isArray(account?.bmIds) && account.bmIds.length > 0 && (
          <div className="text-start space-y-2">
            <span className="flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
              <IdentificationCard size={16} />
              Business Center IDs
            </span>

            <div className="mt-1 grid gap-3 max-h-48 overflow-y-auto">
              {[...account.bmIds].reverse().map((bc, index) => (
                <div
                  key={bc._id || bc.bmId || index}
                  className="flex items-center justify-between gap-3 px-3 py-2 rounded-xl bg-neutral-50 dark:bg-neutral-900/40"
                >
                  <div className="flex flex-col">
                    <span className="font-[400] text-[14px] text-neutral-800 dark:text-neutral-100">
                      {bc.bmId || "Unknown BC ID"}
                    </span>
                    <span className="text-[11px] text-neutral-500 dark:text-neutral-400 flex items-center gap-1">
                      <CalendarBlank size={12} />
                      {bc.date ? new Date(bc.date).toLocaleDateString() : "Created date N/A"}
                    </span>
                  </div>

                  <DecisionBtn
                    decision={bc.decision}
                    payload={{
                      kind: "tiktok_bc",
                      identifierId: bc._id,
                      value: bc.bmId,
                      accountId: account?._id,
                      index,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Google / Snapchat: Email */}
        {(platform === "google" || platform === "snapchat") && (
          <div className="flex items-center justify-between gap-3 px-3 py-2 rounded-xl bg-neutral-50 dark:bg-neutral-900/40">
            <div className="flex flex-col">
              <span className="text-sm text-neutral-500 dark:text-neutral-400 flex items-center gap-2">
                <EnvelopeSimple size={16} />
                Email
              </span>
              <span className="font-medium text-sm font-[400] text-neutral-800 dark:text-neutral-100">
                {account?.email?.value || account?.email || "N/A"}
              </span>
            </div>


          </div>
        )}

        {/* Pages (optional decision per page if you have it) */}
        {platform === "meta" && Array.isArray(account?.pages) && account.pages.length > 0 && (
          <div className="text-start space-y-2">
            <span className="flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
              <SquaresFour size={16} />
              Pages
            </span>
            <div className="grid gap-2">
              {account.pages.map((p, i) => (
                <div
                  key={`${p}-${i}`}
                  className="py-2 px-3 rounded-xl bg-neutral-50 dark:bg-neutral-900/30 text-sm text-neutral-700 dark:text-neutral-300"
                >
                  {p}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

/* ------------------------------------------
   Helpers
-------------------------------------------*/
const formatDate = (raw) => {
  if (!raw) return "N/A"
  const d = new Date(raw)
  const datePart = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
  const timePart = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
  return `${datePart}, ${timePart}`
}

function Th({ children }) {
  return (
    <th className="px-6 py-5 text-left text-[12px] font-[400] text-neutral-500 dark:text-neutral-400 uppercase tracking-[0.08em] whitespace-nowrap">
      {children}
    </th>
  )
}
function Td({ children, className = "" }) {
  return (
    <td className={`px-6 py-4 whitespace-nowrap text-sm text-neutral-700 dark:text-neutral-200 ${className}`}>
      {children}
    </td>
  )
}
function PageBtn({ disabled, onClick, children, aria }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={aria}
      className={`p-1 rounded-xl ${disabled
        ? "text-neutral-400 dark:text-neutral-600 cursor-not-allowed"
        : "text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
        }`}
    >
      {children}
    </button>
  )
}
function getPageNumbers(currentPage, totalPages) {
  if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1)
  if (currentPage <= 3) return [1, 2, 3, 4, "...", totalPages]
  if (currentPage >= totalPages - 2) return [1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
  return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages]
}

const getPlatformDisplayName = (platform) => {
  switch (platform) {
    case "meta":
      return "Meta"
    case "google":
      return "Google"
    case "tiktok":
      return "TikTok"
    case "snapchat":
      return "Snapchat"
    default:
      return platform ? platform.charAt(0).toUpperCase() + platform.slice(1) : ""
  }
}

const getStatusBadgeColorAccount = (status) => {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400"
    case "pending":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400"
    case "reinstated":
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400"
    case "suspended":
      return "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400"
    case "banned":
      return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400"
    default:
      return "bg-neutral-100 text-neutral-800 dark:bg-neutral-900/30 dark:text-neutral-400"
  }
}
const getStatusDotClassAccount = (status) => {
  switch (status) {
    case "active":
    case "reinstated":
      return "bg-green-500"
    case "pending":
      return "bg-yellow-500"
    case "suspended":
      return "bg-orange-500"
    case "banned":
      return "bg-red-500"
    default:
      return "bg-neutral-500"
  }
}

const getStatusBadgeColor = (status) => {
  switch (status) {
    case "completed":
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400"
    case "pending":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400"
    case "rejected":
      return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400"
    case "reversed":
      return "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400"
    default:
      return "bg-neutral-100 text-neutral-800 dark:bg-neutral-900/30 dark:text-neutral-400"
  }
}
const getStatusDotClass = (status) => {
  switch (status) {
    case "completed":
      return "bg-green-500"
    case "pending":
      return "bg-yellow-500"
    case "rejected":
      return "bg-red-500"
    case "reversed":
      return "bg-orange-500"
    default:
      return "bg-neutral-500"
  }
}

const getTypeBadgeColor = (type) => {
  switch (type) {
    case "Top-Up":
      return "bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-400 border border-green-100 dark:border-green-800/60"
    case "Top-Down":
      return "bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-400 border border-red-100 dark:border-red-800/60"
    default:
      return "bg-neutral-50 text-neutral-700 dark:bg-neutral-900/40 dark:text-neutral-300 border border-neutral-100 dark:border-neutral-800/70"
  }
}
const getTypeDotClass = (type) => {
  switch (type) {
    case "Top-Up":
      return "bg-green-500"
    case "Top-Down":
      return "bg-red-500"
    default:
      return "bg-neutral-500"
  }
}

/* ===========================================================
   MAIN
=========================================================== */
const AdAccountDetailsEnhanced = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { currentUser } = useCurrentUser()
  const { checkAccess } = useAccessChecker()

  const canRead = checkAccess("topups", "read")
  const canUpdate = checkAccess("topups", "update")

  const [loading, setLoading] = useState(false)
  const [accountData, setAccountData] = useState(null)

  // tabs
  const [activeTab, setActiveTab] = useState("overview")

  // transactions
  const [transferHistory, setTransferHistory] = useState([])
  const [totalItems, setTotalItems] = useState(0)

  // filters
  const [searchQuery, setSearchQuery] = useState("")
  const [dateRange, setDateRange] = useState({ start: "", end: "" })
  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const [filters, setFilters] = useState({ type: "", status: "", amount: "" })

  // pagination
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 0

  // modals
  const [reshareBMModal, setReshareBMModal] = useState(false)
  const [changeNameAAModal, setChangeNameAAModal] = useState(false)
  const [showWithdrawBalanceModal, setShowWithdrawBalanceModal] = useState(false)
  const [showDetailsModal, setShowDetailsModal] = useState(false)
  const [showStatusModal, setShowStatusModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [selectedTransaction, setSelectedTransaction] = useState(null)

  // ✅ identifier decision modal
  const [showDecisionModal, setShowDecisionModal] = useState(false)
  const [decisionTarget, setDecisionTarget] = useState(null)

  // refresh toggle
  const [done, setDone] = useState(false)
  const handleSuccess = () => setDone((d) => !d)

  const filtersActive = useMemo(() => {
    return (
      !!searchQuery ||
      !!dateRange.start ||
      !!dateRange.end ||
      !!filters.type ||
      !!filters.status ||
      !!filters.amount
    )
  }, [searchQuery, dateRange, filters])

  const typeOptions = useMemo(
    () => [
      { id: "all-types", name: "All Types", value: "" },
      { id: "Transfer", name: "Transfer", value: "Transfer" },
      { id: "Reversal", name: "Reversal", value: "Reversal" },
      { id: "Top-Down", name: "Withdraw", value: "Top-Down" },
      { id: "Top-Up", name: "Top-Up", value: "Top-Up" },
    ],
    []
  )

  const statusOptions = useMemo(
    () => [
      { id: "all-statuses", name: "All Statuses", value: "" },
      { id: "completed", name: "Completed", value: "completed" },
      { id: "pending", name: "Pending", value: "pending" },
      { id: "rejected", name: "Rejected", value: "rejected" },
      { id: "reversed", name: "Reversed", value: "reversed" },
    ],
    []
  )

  const amountOptions = useMemo(
    () => [
      { id: "all-amounts", name: "All Amounts", value: "" },
      { id: "0-50", name: "$0 - $50", value: "0-50" },
      { id: "50-100", name: "$50 - $100", value: "50-100" },
      { id: "100-500", name: "$100 - $500", value: "100-500" },
      { id: "500+", name: "$500+", value: "500+" },
    ],
    []
  )

  const formatCurrency = (amount, currency = "USD") =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(amount || 0)

  const fetchAccountData = async () => {
    try {
      setLoading(true)
      const res = await adAccountsService.get(id)
      const body = res?.data
      if (body?.statusCode === 200 && body?.data) {
        setAccountData(body.data)
      } else {
        setAccountData(null)
      }
    } catch (e) {
      console.error("Rejected to load account data:", e)
      setAccountData(null)
    } finally {
      setLoading(false)
    }
  }

  const fetchTransferHistory = async () => {
    try {
      setLoading(true)
      const requestBody = {
        search: searchQuery,
        type: filters.type,
        status: filters.status,
        amount: filters.amount,
        startDate: dateRange.start,
        endDate: dateRange.end,
        page: currentPage,
        limit: itemsPerPage,
      }
      const res = await transferHistoryService.search(id, requestBody)
      const body = res?.data
      setTransferHistory(body?.data || [])
      setTotalItems(body?.pagination?.totalItems || 0)
    } catch (e) {
      console.error("Rejected to load transfer history:", e)
      setTransferHistory([])
      setTotalItems(0)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAccountData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, done])

  useEffect(() => {
    if (activeTab === "transactions") fetchTransferHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, currentPage, itemsPerPage, done])

  const applyFilters = () => {
    setCurrentPage(1)
    fetchTransferHistory()
  }

  const clearFilters = () => {
    setFilters({ type: "", status: "", amount: "" })
    setSearchQuery("")
    setDateRange({ start: "", end: "" })
  }

  const resetAndRefresh = () => {
    clearFilters()
    setCurrentPage(1)
    fetchTransferHistory()
  }

  const handleExport = () => {
    try {
      const queryParams = new URLSearchParams()
      queryParams.append("account_id", id)
      if (searchQuery) queryParams.append("search", searchQuery)
      if (filters.type) queryParams.append("type", filters.type)
      if (filters.status) queryParams.append("status", filters.status)
      if (dateRange.start) queryParams.append("start_date", dateRange.start)
      if (dateRange.end) queryParams.append("end_date", dateRange.end)

      if (filters.amount) {
        const [min, max] = filters.amount.split("-")
        if (min) queryParams.append("min_amount", min)
        if (max) queryParams.append("max_amount", max.replace("+", ""))
      }

      window.open(`/transfer-history/export?${queryParams.toString()}`, "_blank")
    } catch (e) {
      console.error("Rejected to export data:", e)
    }
  }

  const handlePageChange = (p) => {
    if (p < 1 || p > totalPages) return
    setCurrentPage(p)
  }

  const handlePageSizeChange = (e) => {
    const newSize = Number.parseInt(e.target.value)
    setItemsPerPage(newSize)
    setCurrentPage(1)
  }

  const handleViewDetails = (t) => {
    setSelectedTransaction(t)
    setShowDetailsModal(true)
  }

  const openDecisionForIdentifier = (payload) => {
    setDecisionTarget(payload)
    setShowDecisionModal(true)
  }

  return (
    <div className="lg:p-6 p-3 max-w/full mx-auto text-start bg-white dark:bg-neutral-950">
      {/* Back */}
      <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1 text-sm text-neutral-600 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-white"
        >
          <CaretLeft size={16} />
          <span className="font-medium">Back to Ad Accounts</span>
        </button>
      </div>

      {/* Tabs */}
      <div className="p-3 mb-5 flex items-center justify-between rounded-2xl border border-neutral-200/70 dark:border-neutral-900 bg-white dark:bg-neutral-900/30">
        <nav className="flex -mb-[1px]">
          {["overview", "transactions", checkAccess("adAccounts", "delete") ? "settings" : null]
            .filter(Boolean)
            .map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2.5 flex justify-start gap-3 text-sm font-[400] transition-colors
                ${activeTab === tab
                    ? "bg-yellow-50 backdrop-blur-sm rounded-2xl text-yellow-600 dark:text-yellow-400 dark:bg-yellow-900/20"
                    : "border-transparent text-neutral-500 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-200"
                  }`}
              >
                {tab === "overview" && (
                  <span className="inline-flex items-center gap-2">
                    <SquaresFour size={16} />
                    Overview
                  </span>
                )}
                {tab === "transactions" && (
                  <span className="inline-flex items-center gap-2">
                    <ArrowsLeftRight size={16} />
                    Transactions
                  </span>
                )}
                {tab === "settings" && (
                  <span className="inline-flex items-center gap-2">
                    <Gear size={16} />
                    Settings
                  </span>
                )}
              </button>
            ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={() => { fetchAccountData(); fetchTransferHistory(); }}
            className="inline-flex items-center gap-2 h-10 px-3 rounded-xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900/30 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-800"
            title="Reset"
          >
            <ArrowClockwise size={16} />
            <span className="text-xs">Reset</span>
          </button>

          {currentUser?.role?.name !== "Client" && (
            <button
              onClick={() => setChangeNameAAModal(true)}
              className="inline-flex items-center gap-2 h-10 px-3 rounded-xl border border-neutral-300/10 dark:border-neutral-800/10 bg-black dark:bg-neutral-100 text-neutral-100 dark:text-neutral-900 hover:bg-neutral-900 dark:hover:bg-neutral-200"
            >
              <PencilSimple size={16} />
              <span className="text-xs">Change Ad Account Name</span>
            </button>
          )}

          {["active", "reinstated"].includes(accountData?.status) && (
            <>
              {accountData?.platform === "meta" && (
                <button
                  onClick={() => setReshareBMModal(true)}
                  className="inline-flex items-center gap-2 h-10 px-3 rounded-xl border border-neutral-300/10 dark:border-neutral-800/10 bg-black dark:bg-neutral-100 text-neutral-100 dark:text-neutral-900 hover:bg-neutral-900 dark:hover:bg-neutral-200"
                >
                  <ShareNetwork size={16} />
                  <span className="text-xs">Re-Share BM</span>
                </button>
              )}

              {accountData?.platform === "tiktok" && (
                <button
                  onClick={() => setReshareBMModal(true)}
                  className="inline-flex items-center gap-2 h-10 px-3 rounded-xl border border-neutral-300/10 dark:border-neutral-800/10 bg-black dark:bg-neutral-100 text-neutral-100 dark:text-neutral-900 hover:bg-neutral-900 dark:hover:bg-neutral-200"
                >
                  <ShareNetwork size={16} />
                  <span className="text-xs">Re-Share BC</span>
                </button>
              )}

            </>
          )}

          {/* Withdrawing remaining balance must work at ANY account status —
              especially banned/suspended, when it matters most. Still requires
              the topups permission and a loaded account (TopDown reads
              account._id). */}
          {accountData?._id && checkAccess("topups", "create") && (
            <button
              onClick={() => setShowWithdrawBalanceModal(true)}
              className="inline-flex items-center gap-2 h-10 px-3 rounded-xl border border-neutral-300/10 dark:border-neutral-800/10 bg-black dark:bg-neutral-100 text-neutral-100 dark:text-neutral-900 hover:bg-neutral-900 dark:hover:bg-neutral-200"
            >
              <CurrencyDollar size={16} />
              <span className="text-xs">Create Withdraw Request</span>
            </button>
          )}
        </div>
      </div>

      {/* LOADING */}
      {loading && (
        <div className="flex items-center justify-center h-40">
          <SpinnerGap size={30} className="animate-spin text-neutral-600 dark:text-neutral-400" />
        </div>
      )}

      {/* OVERVIEW */}
      {activeTab === "overview" && accountData && (
        <div className="space-y-5">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5">
            {/* Basic */}
            <div className="p-5 rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
              <h3 className="mb-4 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
                <IdentificationCard size={16} /> Basic Information
              </h3>

              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
                    <GlobeHemisphereWest size={16} /> Platform
                  </span>
                  <div className="flex items-center gap-2">
                    {getPlatformIcon(accountData.platform)}
                    <span className="text-sm font-medium text-neutral-900 dark:text-white">
                      {getPlatformDisplayName(accountData.platform)}
                    </span>
                  </div>
                </div>

                <InfoRow label="Ad Account ID" value={accountData.adAccountId} icon={<HashStraight size={16} />} />
                <InfoRow label="Ad Account Name" value={accountData.account_name} icon={<TagSimple size={16} />} />

                <div className="flex justify-between items-center">
                  <span className="flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
                    <ShieldCheck size={16} /> Status
                  </span>
                  <span
                    className={`inline-flex gap-2 rounded-full capitalize px-2 py-0.5 items-center text-xs font-medium ${getStatusBadgeColorAccount(
                      accountData.status
                    )}`}
                  >
                    <span className={`w-1.5 h-1.5 ${getStatusDotClassAccount(accountData.status)} rounded-full`} />
                    {accountData.status ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>

            {/* Financial */}
            <div className="p-5 rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
              <h3 className="mb-4 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
                <Coins size={16} /> Financial Information
              </h3>

              <div className="space-y-3">
                <InfoRow label="Currency" value={accountData.currency} icon={<CurrencyCircleDollar size={16} />} />
                <InfoRow
                  label="Credit Account"
                  value={accountData.credit_account?.account_name}
                  icon={<Buildings size={16} />}
                />
                <InfoRow
                  label="Credit Account Balance"
                  value={`${accountData.credit_account?.balance
                    ? (Math.round(accountData.credit_account.balance * 100) / 100).toFixed(2)
                    : "0.00"
                    }`}
                  icon={<CurrencyDollar size={16} />}
                />
                <InfoRow
                  label="Credit Reference"
                  value={accountData.credit_account?.account_id}

                  icon={<Key size={16} />}
                />
              </div>
            </div>

            {/* Technical */}
            <div className="p-5 rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
              <h3 className="mb-4 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
                <GearSix size={16} /> Technical Details
              </h3>

              <div className="space-y-3">
                <InfoRow label="Timezone" value={accountData.timezone} icon={<IdentificationCard size={16} />} />
                <InfoRow label="Category" value={accountData.category} icon={<TagSimple size={16} />} />
                <InfoRow label="Website" value={accountData.link} icon={<Globe size={16} />} />
              </div>
            </div>

            {/* ✅ Identifiers (decision per item) */}
            <IdentifiersCard
              account={accountData}
              currentUser={currentUser}
              onOpenDecision={openDecisionForIdentifier}
            />

            {/* Client */}
            <div className="p-5 rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
              <h3 className="mb-4 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
                <UserIcon size={16} /> Client Information
              </h3>

              <div className="space-y-3">
                <InfoRow
                  label="Client Reference"
                  value={accountData.user?.reference || accountData.user?.fullName}
                  icon={<UserCircle size={16} />}
                />

                <InfoRow label="Client ID" value={accountData.user?.clientId} icon={<IdentificationCard size={16} />} />
                <InfoRow label="Email Address" value={accountData.user?.email} icon={<IdentificationCard size={16} />} />
                <InfoRow label="Company Name" value={accountData.user?.businessName} icon={<IdentificationCard size={16} />} />
                <InfoRow label="WhatsApp Number" value={accountData.user?.phone} icon={<IdentificationCard size={16} />} />

                <InfoRow
                  label="Created"
                  value={accountData.createdAt ? formatDateGlobal(accountData.createdAt) : null}
                  icon={<CalendarBlank size={16} />}
                />
              </div>
            </div>

            {/* Provider */}
            {currentUser?.role?.name !== "Client" && (
              <div className="p-5 rounded-xl  border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
                <h3 className="mb-4 text-sm font-medium text-neutral-900 dark:text-white flex items-center gap-2">
                  <Handshake size={16} /> Provider Information
                </h3>

                <div className="space-y-3">
                  <InfoRow label="Provider Name" value={accountData.provider?.name} icon={<Storefront size={16} />} />
                  <InfoRow label="Partner BM" value={accountData.parentBmId} icon={<GitBranch size={16} />} />
                  <InfoRow label="Provider Type" value={accountData.provider?.type} badge icon={<TagSimple size={16} />} />
                  <InfoRow label="Provider Email" value={accountData.provider?.email} icon={<EnvelopeSimple size={16} />} />
                  <InfoRow label="Provider Phone" value={accountData.provider?.phone} icon={<Phone size={16} />} />

                  {accountData.provider?.platforms?.length > 0 && (
                    <div className="flex justify-between gap-3 flex-wrap items-start">
                      <span className="flex items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
                        <DeviceMobile size={16} /> Supported Platforms
                      </span>
                      <div className="flex flex-wrap gap-1">
                        {accountData.provider.platforms.map((p, i) => (
                          <span
                            key={i}
                            className="inline-flex px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400"
                          >
                            {p}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {accountData.provider?.notes && (
                    <div>
                      <span className="flex items-center gap-2 mb-1 text-sm text-neutral-500 dark:text-neutral-400">
                        <Note size={16} /> Notes
                      </span>
                      <p className="text-sm text-neutral-700 dark:text-neutral-300 leading-relaxed">
                        {accountData.provider.notes}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {(accountData.notes || accountData.reason) && (
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              {accountData.notes && <NotesBox title="Notes" content={accountData.notes} icon={<NotePencil size={16} />} />}
              {/* {accountData.reason && (
                <NotesBox title="Reason" content={accountData.reason} icon={<WarningCircle size={16} />} />
              )} */}
            </div>
          )}
        </div>
      )}

      {/* TRANSACTIONS */}
      {activeTab === "transactions" && (
        <div className="text-start">
          {/* Search & Filters */}
          <div className="flex flex-wrap gap-3 mb-5">
            <div className="relative flex-grow max-w-xs">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <MagnifyingGlass size={16} className="text-neutral-400" />
              </div>
              <input
                type="text"
                placeholder="Search by ID, notes, or reference"
                className="h-10 w-full border pl-10 pr-10 text-sm border-neutral-200 dark:border-neutral-900 rounded-xl placeholder-neutral-500 ring-yellow-500/60 dark:ring-yellow-400/60 bg-white dark:bg-neutral-900/30 text-neutral-700 dark:text-neutral-200 focus:outline-none focus:ring-1 transition-shadow"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && applyFilters()}
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-neutral-500 hover:text-yellow-600 dark:hover:text-yellow-400"
                onClick={applyFilters}
                aria-label="Submit search"
              >
                <ArrowRight size={16} />
              </button>
            </div>

            <div className="relative">
              <DateRangePicker
                onRangeChange={(range) => setDateRange(range)}
                value={dateRange}
                className={
                  dateRange.start || dateRange.end
                    ? "border-yellow-500 bg-yellow-50 text-yellow-600 dark:border-yellow-600 dark:bg-yellow-900/20 dark:text-yellow-400"
                    : ""
                }
              />
            </div>

            <button
              className={`flex items-center gap-2 px-4 h-10 w-fit border text-sm rounded-xl ${showMoreFilters
                ? "border-yellow-500 bg-yellow-50 text-yellow-600 dark:border-yellow-600 dark:bg-yellow-900/20 dark:text-yellow-400"
                : "border-neutral-200 dark:border-neutral-900 bg-white dark:bg-neutral-900/30 text-neutral-700 dark:text-neutral-200"
                }`}
              onClick={() => setShowMoreFilters((s) => !s)}
            >
              <span className="text-sm">{showMoreFilters ? "Hide filters" : "More filters"}</span>
              {showMoreFilters ? <X size={16} /> : <PlusCircle size={16} />}
            </button>

            <button
              className="flex items-center gap-2 h-10 px-4 border border-neutral-200 dark:border-neutral-900 rounded-xl bg-white dark:bg-neutral-900/30 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-800"
              onClick={resetAndRefresh}
              aria-label="Reset filters"
            >
              <ArrowClockwise size={16} />
              <span className="text-sm">Reset</span>
            </button>

            {filtersActive && !showMoreFilters && (
              <button
                className="flex items-center text-sm justify-center px-4 gap-2 h-10 bg-neutral-900 hover:bg-black text-white rounded-xl shadow-sm"
                onClick={applyFilters}
              >
                <FunnelSimple size={16} />
                <span className="text-sm">Apply Filters</span>
              </button>
            )}

            <button
              className="flex items-center justify-center h-10 w-10 border border-neutral-200 dark:border-neutral-900 rounded-xl bg-white dark:bg-neutral-900/30 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-800"
              onClick={handleExport}
              title="Export data"
            >
              <DownloadSimple size={16} className="text-neutral-500 dark:text-neutral-400" />
            </button>
          </div>

          {/* Expanded Filters */}
          {showMoreFilters && (
            <div className="mb-5 p-5 z-[9999] rounded-xl border border-neutral-200/70 dark:border-neutral-900 bg-white/70 dark:bg-neutral-900/30 backdrop-blur-sm shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-sm font-medium text-neutral-800 dark:text-white flex items-center gap-2">
                  <FunnelSimple size={16} /> More filters
                </h2>
                <button
                  onClick={clearFilters}
                  className="text-sm text-neutral-500 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-neutral-300 flex items-center gap-1.5"
                >
                  <X size={14} />
                  <span>Clear all</span>
                </button>
              </div>

              <div className="grid text-start grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-2">
                <div className="relative">
                  <label className="block text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Transaction Type
                  </label>
                  <SearchableSelect
                    options={typeOptions}
                    value={filters.type}
                    onChange={(v) => setFilters((p) => ({ ...p, type: v }))}
                    placeholder="Transaction Type"
                    icon={<Activity size={16} />}
                  />
                </div>

                <div className="relative">
                  <label className="block text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-1">Status</label>
                  <SearchableSelect
                    options={statusOptions}
                    value={filters.status}
                    onChange={(v) => setFilters((p) => ({ ...p, status: v }))}
                    placeholder="Status"
                    icon={<Activity size={16} />}
                  />
                </div>

                <div className="relative">
                  <label className="block text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Amount Range
                  </label>
                  <SearchableSelect
                    options={amountOptions}
                    value={filters.amount}
                    onChange={(v) => setFilters((p) => ({ ...p, amount: v }))}
                    placeholder="Amount Range"
                    icon={<CurrencyDollar size={16} />}
                  />
                </div>

                <div className="flex items-end">
                  <button
                    className="inline-flex items-center justify-center px-4 gap-2 h-10 rounded-xl bg-neutral-900 text-white hover:bg-black"
                    onClick={applyFilters}
                  >
                    <FunnelSimple size={16} />
                    <span className="text-sm">Apply Filters</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Table + pagination */}
          <div className="border border-neutral-150 dark:border-neutral-900 rounded-lg bg-white dark:bg-neutral-950">
            {loading ? (
              <div className="flex items-center justify-center h-64">
                <SpinnerGap
                  size={30}
                  className="animate-spin text-neutral-600 dark:text-neutral-400"
                />
              </div>
            ) : transferHistory.length > 0 ? (
              <>
                <div className="overflow-x-auto rounded-t-lg">
                  <table className="min-w-full divide-y divide-neutral-150 dark:divide-neutral-800">
                    <thead className="z-30 bg-neutral-50/80 dark:bg-neutral-900/40">
                      <tr>
                        <Th>Date</Th>
                        <Th>Platform</Th>
                        <Th>Ad Account</Th>
                        <Th>Net Amount</Th>

                        <Th>
                          {currentUser?.role?.name !== "Client" ? "Client Fee" : "Fees"}
                        </Th>

                        {/* ✅ Only show Provider Fee + Profit for non-client AND not Withdraw */}
                        {currentUser?.role?.name !== "Client" && (
                          <>
                            <Th>Provider Fee</Th>
                            <Th>Weberz Fee</Th>
                          </>
                        )}
                        <Th>Total</Th>

                        {/* ✅ Rename column to generic "Net Amount" */}
                        <Th>Type</Th>
                        <Th>Status</Th>
                        <Th>Actions</Th>
                      </tr>
                    </thead>

                    <tbody className="bg-white text-start dark:bg-neutral-950 divide-y divide-neutral-100 dark:divide-neutral-800">
                      {transferHistory.map((t) => {
                        const currency = t.currency || "USD";

                        // ✅ platform resolution
                        const platform =
                          t.destination_platform ||
                          t.source_platform ||
                          t.destination_account?.platform ||
                          t.source_account?.platform;

                        const isTopDown = t.type === "Top-Down";

                        // ✅ Withdraw: no provider/profit AND net shown as TOTAL
                        // ✅ Top-Up: net shown as net_amount_received
                        const netDisplay = isTopDown
                          ? Number(t.net_amount_received || 0)
                          : Number(t.net_amount_received || 0);

                        // ✅ show provider/profit only for non-client AND not Top-Down
                        const showProviderProfit =
                          currentUser?.role?.name !== "Client" && !isTopDown;

                        return (
                          <tr
                            key={t._id}
                            className="hover:bg-neutral-50/80 dark:hover:bg-neutral-900/60 transition-colors"
                          >
                            <Td>
                              <span className="font-[400] text-neutral-800 dark:text-neutral-100">
                                {formatDate(t.createdAt)}
                              </span>
                            </Td>

                            <Td>
                              <div className="flex items-center gap-2">
                                {getPlatformIcon(platform)}
                                <span className="text-sm font-[300]">
                                  {getPlatformDisplayName(platform)}
                                </span>
                              </div>
                            </Td>

                            <Td>
                              <span className="text-[14px] font-[300]">
                                {t.destination_account?.account_name || "-"}
                              </span>
                            </Td>

                            {/* ✅ Net Amount column */}
                            <Td className="font-[400] text-sm">
                              {formatCurrency(netDisplay, currency)}
                            </Td>
                            <Td>
                              {t.client_fee_amount || t.client_fee_percentage ? (
                                <div className="text-sm text-center">
                                  <div className="font-[400]">
                                    {formatCurrency(
                                      Number(t.client_fee_amount || 0),
                                      currency
                                    )}
                                  </div>
                                  <div className="text-neutral-500">
                                    {Number(t.client_fee_percentage || 0)}%
                                  </div>
                                </div>
                              ) : (
                                <div className="flex justify-center items-center ">
                                  <span className="text-neutral-400   mx-autotext-right text-sm">-</span>

                                </div>)}
                            </Td>

                            {currentUser?.role?.name !== "Client" && (
                              <>
                                {/* ✅ Provider Fee: "-" for Withdraw */}
                                <Td>
                                  {showProviderProfit ? (
                                    t.provider_fee_amount || t.provider_fee_percentage ? (
                                      <div className="text-sm text-center">
                                        <div className="font-[400]">
                                          {formatCurrency(
                                            Number(t.provider_fee_amount || 0),
                                            currency
                                          )}
                                        </div>
                                        <div className="text-neutral-500">
                                          {Number(t.provider_fee_percentage || 0)}%
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="flex justify-center items-center ">
                                        <span className="text-neutral-400   mx-autotext-right text-sm">-</span>

                                      </div>)
                                  ) : (
                                    <div className="flex justify-center items-center ">
                                      <span className="text-neutral-400   mx-autotext-right text-sm">-</span>

                                    </div>)}
                                </Td>

                                {/* ✅ Profit: "-" for Withdraw */}
                                <Td
                                  className={
                                    showProviderProfit
                                      ? Number(t.profit_amount || 0) >= 0
                                        ? "text-green-600"
                                        : "text-red-600"
                                      : ""
                                  }
                                >
                                  {showProviderProfit ? (
                                    <div className="text-sm text-center">
                                      <div className="font-[400]">
                                        {formatCurrency(
                                          Number(t.profit_amount || 0),
                                          currency
                                        )}
                                      </div>
                                      <div className="text-neutral-500">
                                        {Number(
                                          (t.client_fee_percentage || 0) -
                                          (t.provider_fee_percentage || 0)
                                        )}
                                        %
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="flex justify-center items-center ">
                                      <span className="text-neutral-400   mx-autotext-right text-sm">-</span>

                                    </div>)}
                                </Td>
                              </>
                            )}
                            <Td className="font-[400] text-sm">
                              {formatCurrency(Number(t.amount || 0), currency)}
                            </Td>



                            <Td>
                              <span
                                className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-[400] ${getTypeBadgeColor(
                                  t.type
                                )}`}
                              >
                                <span
                                  className={`w-2 h-2 mr-1.5 rounded-full ${getTypeDotClass(
                                    t.type
                                  )}`}
                                />
                                {t.type === "Top-Up"
                                  ? "Top-Up"
                                  : t.type === "Top-Down"
                                    ? "Withdraw"
                                    : t.type}
                              </span>
                            </Td>

                            <Td>
                              <span
                                className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-[400] ${getStatusBadgeColor(
                                  t.status
                                )}`}
                              >
                                <span
                                  className={`w-2 h-2 mr-1.5 rounded-full ${getStatusDotClass(
                                    t.status
                                  )}`}
                                />
                                {t.status
                                  ? t.status[0]?.toUpperCase() + t.status.slice(1)
                                  : "N/A"}
                              </span>
                            </Td>

                            <Td className="text-sm font-[300] items-center mt-1.5 flex gap-2">
                              {canRead && (
                                <button
                                  onClick={() => handleViewDetails(t)}
                                  className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 bg-blue-600/10 p-1.5 rounded-xl transition-colors"
                                >
                                  <Eye size={14} />
                                </button>
                              )}

                              {currentUser?.role?.name !== "Client" &&
                                canUpdate && (
                                  <button
                                    onClick={() => {
                                      setSelectedTransaction(t);
                                      setShowStatusModal(true);
                                    }}
                                    className="text-amber-600 hover:text-amber-700 dark:text-amber-400 dark:hover:text-amber-300 bg-amber-600/10 p-1.5 rounded-xl transition-colors"
                                  >
                                    <PencilSimple size={14} />
                                  </button>
                                )}
                            </Td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="px-6 py-3 flex flex-col sm:flex-row items-center justify-between border-t border-neutral-150 dark:border-neutral-900 bg-neutral-50/60 dark:bg-neutral-900/40 rounded-b-lg">
                  <div className="flex items-center mb-4 sm:mb-0">
                    <span className="text-[13px] text-neutral-600 dark:text-neutral-400">
                      Showing {transferHistory.length} of {totalItems} transfers
                    </span>

                    <div className="ml-4 flex items-center gap-2">
                      <span className="text-[12px] text-neutral-500 dark:text-neutral-400">
                        Rows
                      </span>

                      <div className="relative">
                        <select
                          value={itemsPerPage}
                          onChange={handlePageSizeChange}
                          className="h-8 pl-3 pr-8 text-[12px] border border-neutral-200/80 dark:border-neutral-800 rounded-xl bg-white dark:bg-neutral-950/80 text-neutral-800 dark:text-neutral-100 shadow-sm focus:outline-none focus:ring-1 focus:ring-neutral-300 dark:focus:ring-neutral-600 appearance-none cursor-pointer"
                        >
                          <option value={5}>5 / page</option>
                          <option value={10}>10 / page</option>
                          <option value={25}>25 / page</option>
                          <option value={50}>50 / page</option>
                          <option value={100}>100 / page</option>
                        </select>
                        <CaretDown
                          size={14}
                          className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-neutral-500 dark:text-neutral-400"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <PageBtn
                      disabled={currentPage === 1 || totalPages === 0}
                      onClick={() => handlePageChange(1)}
                      aria="First page"
                    >
                      <CaretDoubleLeft size={14} />
                    </PageBtn>
                    <PageBtn
                      disabled={currentPage === 1 || totalPages === 0}
                      onClick={() => handlePageChange(currentPage - 1)}
                      aria="Previous page"
                    >
                      <CaretLeft size={14} />
                    </PageBtn>

                    <div className="flex items-center space-x-1">
                      {getPageNumbers(currentPage, totalPages).map((page, idx) =>
                        page === "..." ? (
                          <span
                            key={`ellipsis-${idx}`}
                            className="px-2 py-1 text-neutral-500 dark:text-neutral-400"
                          >
                            ...
                          </span>
                        ) : (
                          <button
                            key={page}
                            onClick={() => handlePageChange(page)}
                            className={`w-7 h-7 flex items-center justify-center rounded-xl text-[13px] ${currentPage === page
                              ? "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-black"
                              : "text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                              }`}
                          >
                            {page}
                          </button>
                        )
                      )}
                    </div>

                    <PageBtn
                      disabled={currentPage === totalPages || totalPages === 0}
                      onClick={() => handlePageChange(currentPage + 1)}
                      aria="Next page"
                    >
                      <CaretRight size={14} />
                    </PageBtn>
                    <PageBtn
                      disabled={currentPage === totalPages || totalPages === 0}
                      onClick={() => handlePageChange(totalPages)}
                      aria="Last page"
                    >
                      <CaretDoubleRight size={14} />
                    </PageBtn>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex flex-col text-sm items-center justify-center h-64 p-8">
                <div className="p-2 rounded-full bg-neutral-100 dark:bg-neutral-900/20 flex items-center justify-center mb-4">
                  <WarningCircle
                    size={24}
                    className="text-neutral-600 dark:text-neutral-400"
                  />
                </div>
                <h3 className="text-xl font-[400] text-neutral-900 dark:text-white mb-2">
                  No Transactions Found
                </h3>
                <p className="text-sm text-neutral-500 dark:text-neutral-400 text-center max-w-md mb-6">
                  {filtersActive
                    ? "No transactions match your search criteria. Try adjusting your filters or search term."
                    : "There are no transactions in the system yet."}
                </p>
                <button
                  onClick={resetAndRefresh}
                  className="px-4 py-2 border border-neutral-200 dark:border-neutral-900 rounded-xl bg-white dark:bg-neutral-900/40 text-neutral-800 dark:text-white hover:bg-neutral-50 dark:hover:bg-neutral-700 transition-colors flex items-center gap-2"
                >
                  <ArrowClockwise size={16} />
                  Reset Filters
                </button>
              </div>
            )}
          </div>

        </div>
      )}

      {/* SETTINGS */}
      {activeTab === "settings" && checkAccess("adAccounts", "delete") && (
        <div className="space-y-5">
          <div className="p-6 rounded-xl border border-red-200/70 dark:border-red-600/30 bg-red-600/10 backdrop-blur-sm shadow-sm">
            <div className="flex items-center gap-2 mb-3">
              <WarningCircle size={18} className="text-red-600" />
              <h3 className="text-base font-semibold text-red-600">Danger Zone</h3>
            </div>
            <p className="text-sm text-neutral-800 dark:text-neutral-200 mb-4">
              Be careful, these actions can have irreversible consequences.
            </p>
            <button
              onClick={() => setShowDeleteModal(true)}
              className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-xl shadow-sm"
            >
              <TrashSimple size={16} />
              Delete Ad Account
            </button>
          </div>
        </div>
      )}

      {/* MODALS */}
      {showDetailsModal && (
        <TransactionDetailsModal isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)} transaction={selectedTransaction} currentUser={currentUser}
        />
      )}

      {/* ✅ Decision Modal (identifier-based) */}
      {showDecisionModal && (
        <ApproveRejectModal
          isOpen={showDecisionModal}
          onClose={() => setShowDecisionModal(false)}
          // IMPORTANT: update your modal to accept this object
          identifier={decisionTarget}
          onSuccess={handleSuccess}
        />
      )}

      {reshareBMModal && (
        <ReshareBMModal
          isOpen={reshareBMModal}
          onClose={() => setReshareBMModal(false)}
          account={accountData}
          onSuccess={handleSuccess}
          type={accountData?.platform === "meta" ? "BM" : "BC"}
        />
      )}

      {changeNameAAModal && (
        <ChangeAdAccountNameDialog
          isOpen={changeNameAAModal}
          onClose={() => setChangeNameAAModal(false)}
          account={accountData}
          onSuccess={handleSuccess}
        />
      )}

      <WithdrawBalanceModal
        isOpen={showWithdrawBalanceModal}
        onClose={() => setShowWithdrawBalanceModal(false)}
        account={accountData}
        onSuccess={handleSuccess}
      />

      {showStatusModal && (
        <ChangeStatusModal
          isOpen={showStatusModal}
          onClose={() => setShowStatusModal(false)}
          transaction={selectedTransaction}
          onSuccess={handleSuccess}
        />
      )}

      {showDeleteModal && (
        <DeleteAdAccountModal
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          accountId={id}
        />
      )}
    </div>
  )
}

/* ------------------------------------------
   Delete Modal
-------------------------------------------*/
const DeleteAdAccountModal = ({ isOpen, onClose, accountId }) => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleDelete = async () => {
    try {
      setLoading(true)
      await adAccountsService.delete(accountId)
      onClose()
      navigate("/ad-accounts")
    } catch (error) {
      console.error("Rejected to delete ad account:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/50 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="bg-white dark:bg-neutral-900/30 dark:border-neutral-900 text-start rounded-xl shadow-lg p-6 w-full max-w-md"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            <h2 className="text-md font-medium text-neutral-900 dark:text-white mb-3">Delete Ad Account</h2>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
              Are you sure you want to delete this ad account? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm rounded-xl border border-neutral-300 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-700"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={loading}
                className={`px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-xl shadow-sm ${loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
              >
                {loading ? <SpinnerGap size={16} className="animate-spin" /> : "Delete"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default AdAccountDetailsEnhanced
